(function () {
    'use strict';

    var routes = null;

    angular
        .module('weissmanApp')
        // routes is built internally in configRoutes, but make the object availble to other services
        // by exposing a factory to return it.
        .factory('routes', function () {
            return routes;
        })
        .config(configRoutes);

    configRoutes.$inject = [
        '$urlRouterProvider',
        '$stateProvider',
        'Roles',
        'EntityTypeIDs',
        'InstanceRights',
        'ContactModalOrigin',
    ];

    function configRoutes(
        $urlRouterProvider,
        $stateProvider,
        Roles,
        EntityTypeIDs,
        InstanceRights,
        ContactModalOrigin,
    ) {
        var baseUrl = 'app/';

        routes = {
            logout: {
                onEnter: [
                    'accountService',
                    function (accountService) {
                        return accountService.logout().then(function () {
                            return false;
                        });
                    },
                ],
            },
            contact: {
                url: '/contacts/:contactId',
                onEnter: [
                    'sd.Contacts.Service',
                    '$stateParams',
                    async (contactsService, $stateParams) => {
                        if ($stateParams.contactId) {
                            await contactsService.openContactDialog(
                                $stateParams.contactId,
                                ContactModalOrigin.ContactsList,
                            );
                        }
                    },
                ],
            },
            unauthorizedAccess: {
                template:
                    '<p class="text-warning text-center lead" style="margin-top: 50px;">You do not have permission to view this page. If you have any questions, please contact the site administrator.</p>',
                resolve: {
                    $title: function () {
                        return 'Unauthorized Access';
                    },
                },
            },
            // TODO: Consider eliminating the document preview version of this route and moving the files
            // to more logical locations; they're the same route except for the URL
            // 'attachmentPopup': {
            //     url: '/attachmentPopup',
            //     resolve: {
            //         $title: function () {
            //             return 'Attachment Viewer';
            //         }
            //     },
            //     templateUrl: baseUrl + 'Processing/Documents/Popups/_filePreview.html',
            //     controller: 'FilePreviewController',
            //     controllerAs: 'vm'
            // }
        };

        // Hack to produce a resolve on every state definition
        // (see https://stackoverflow.com/a/33280010; this was needed
        // for navigation warnings)
        var originalStateFunction = $stateProvider.state;
        $stateProvider.state = function (name, definition) {
            if (!definition.resolve) {
                definition.resolve = {};
            }

            return originalStateFunction.apply(this, arguments);
        };
        // End hack

        var routeKeys = Object.keys(routes);

        for (var i = 0; i < routeKeys.length; i++) {
            var routeKey = routeKeys[i];

            $stateProvider.state(routeKey, routes[routeKey]);
        }
    }
})();
